import { render } from "./BeginOrderForm.vue?vue&type=template&id=7244032c"
import script from "./BeginOrderForm.vue?vue&type=script&lang=js"
export * from "./BeginOrderForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__